import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

const basePath = '/report'
const onlinePath = '/online/online'
const onlineReportPath = '/online/report'

const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

/**
 * 获取报表下载地址
 * @author wangk 2018-08-24T13:59:37+0800
 * @param  {Object} params {
 *                           examId: '', orgId: '',
 *                           level: 0, // (教育局报表), 1(学校报表), 2(班级报表), 3(区校班), 4(教研员), 5(教师工作量)
 *                           type: 0 // 0: 在成绩界面下载报表, 1: 在首页下载报表
 *                         }
 * @return {[type]}        [description]
 */
const getReportDownloadUrl = (params = {}) => {
  let url = basePath + '/getReportDownloadUrl' +
            '/' + params.examId +
            '/' + params.orgId +
            '/' + params.level +
            '/' + params.type
  return axios.post(url, 'subjectName=' + params.subjectName, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询机构已参加的且已出分的考试(考试趋势对比)
 * @author wangk 2018-08-27T15:06:03+0800
 * @param  {Object} params {
 *                           orgId: "1525835962859",
 *                           unitLevel: "0",
 *                           pageNum: 1,
 *                           pageSize: 8,
 *                           gradeLevels: [],
 *                           timeStart: "",
 *                           timeEnd: ""
 *                         }
 * @return {[type]}        [description]
 */
const getOrgExams = (params = {}) => {
  return axios.post(onlinePath + '/getOrgExams', 'json=' + JSON.stringify(params), axiosConfig)
    .then(res => res.data)
}

/**
 * 搜索考试(考试趋势对比)
 * @author wangk 2018-08-27T15:10:11+0800
 * @param  {Object} params {"orgId":"1525835962859","pageNum":1,"pageSize":8,"unitLevel":"0","searchCondition":"测试"}
 * @return {[type]}        [description]
 */
const searchOrgExams = (params = {}) => {
  return axios.post(onlinePath + '/searchOrgExams', 'json=' + JSON.stringify(params), axiosConfig)
    .then(res => res.data)
}

/**
 * 查询趋势对比历史记录
 * @author wangk 2018-08-27T17:24:07+0800
 * @param  {Object} params {"orgId":"1525835962859","timeStart":"","timeEnd":"","pageNum":1,"pageSize":8}
 * @return {[type]}        [description]
 */
const getExamTrendComparisonHistory = (params = {}) => {
  return axios.post(onlinePath + '/getExamTrendComparisonHistory', 'json=' + JSON.stringify(params), axiosConfig)
    .then(res => res.data)
}

/**
 * 考试对比
 * @author wangk 2018-08-28T14:00:32+0800
 * @param  {Object} params { orgId: '', exams: [{}] }
 * @return {[type]}        [description]
 */
const examComparison = (params = {}) => {
  return axios.post(onlinePath + '/examComparison', 'json=' + JSON.stringify(params), axiosConfig)
    .then(res => res.data)
}

/*
 * 查询考试的报表参数
 * @param {object} data {"examid":""}
 * @return promise
 */
const queryExamReportConfig = (data) => {
  let param = `json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/queryExamReportConfig`, param, axiosConfig)
    .then(res => res.data)
}

/*
 * 设置考试报表参数
 * @param {object} data
 * @return promise
 */
const setExamReportConfig = (data) => {
  let param = `json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/setExamReportConfig`, param, axiosConfig)
    .then(res => res.data)
}

/*
 * 发布报表
 * @param {string} data [examId]
 * @return promise
 */
const publishReport = (data) => {
  return axios.post(`${basePath}/publishReport`, data)
    .then(res => res.data)
}

/**
 * 查询成绩下载链接
 * @author wangk 2018-10-23T09:56:19+0800
 * @param  {Object} params {
 *                           data: {
 *                             orgId: '123',
 *                             examId: '123',
 *                             userId: '123',
 *                             role: '4',
 *                             subjectIds: ['123'], // 暂时只支持单个科目下载, 与 `totalScore` 互斥
 *                             totalScore: true // 是否下载总分, 与 `subjectIds` 互斥
 *                           }
 *                         }
 * @return {[type]}      [description]
 */
const queryDownloadScoreURL = (params = {}) => {
  return axios.post(`${basePath}/queryDownloadScoreURL`, params)
    .then(res => res.data)
}

/**
 * 生成报表
 * @author wangk 2018-10-29T09:20:43+0800
 * @param  {Object} params {
 *                           data: {
 *                             orgId: '', examId: '', userId: ''
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const calcReport = (params = {}) => {
  return axios.post(`${basePath}/calcReport`, params)
    .then(res => res.data)
}

/**
 * 批量生成报表
 * @author chenxb 2020-09-25T17:20:43+0800
 * @param  {Object} params {
 *                           data: [{
 *                             orgId: '', examId: '', userId: ''
 *                           }]
 *                         }
 * @return {[type]}        [description]
 */
const batchCalcReport = (params = {}) => {
  return axios.post(`${basePath}/calcReportBatch`, params)
    .then(res => res.data)
}

/**
 * 获取下载报表链接
 * @author wangk 2018-10-29T09:28:43+0800
 * @param  {Object} params {
 *                           data: {
 *                             orgId: '', examId: '', userId: ''
 *                           }
 *                         }
 * @return {[type]}        [description]
 */
const queryDownloadReportURL = (params = {}) => {
  return axios.post(`${basePath}/queryDownloadReportURL`, params)
    .then(res => res.data)
}

/**
 * 科目成绩上报
 * @author changh 2019-10-10T09:28:43+0800
 * @param  {Object}
 * @return {[type]}        [description]
 */
const initExamSubjectResultData = (params = {}) => {
  return axios.post(`${basePath}/initExamSubjectResultData`, params)
    .then(res => res.data)
}

/**
 * 检查科目成绩是否存在，用于检测考试是否可以上报
 * @author changh 2019-10-10T09:28:43+0800
 * @param  {"examid":"1592988984739","subjectid":"1571295413305"}
 * @return {[type]}        [description]
 */
const checkSubjectResultUploaded = (data) => {
  let param = `app=uploadResultCheck&json=${JSON.stringify(data)}`
  return axios.post(`${basePath}/checkSubjectExist`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询考生分数
 * @author changh 2021-08-31T09:28:43+0800
 * @param  {Object}
 * @return {[type]}        [description]
 */
const queryStudentScoreDetail = (data = {}) => {
  let param = `json=${JSON.stringify(data)}`
  return axios.post(`${onlineReportPath}/studentSituation/queryStudentScoreDetail`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询总分-报表等级参数
 * @author changh 2021-08-31T09:28:43+0800
 * @param  {data:{examId:""}}
 * @return {
    "data": {
      "gradeType": 11,
      "gradeFlag": false,
      "scoreFlag": true
    }
  }        [description]
 */
const getExamGradeParam = (params = {}) => {
  return axios.post(`${basePath}/getExamGradeParam`, params).then(res => res.data)
}
/**
 * 查询单科目-报表等级参数
 * @author changh 2021-08-31T09:28:43+0800
 * @param  {data:{examId:"",subjectId:""}}
 * @return {
    "data": {
      gradeParam:{
        "gradeType": 11,
        "gradeFlag": false,
        "scoreFlag": true,
        gradeSubjectParam:[
          gradeParamArray:[{
            segmentKey:'',
            segmentValue:''
          }],
          wenliType:（none，arts，science）
        ]
      }
    }
  }        [description]
 */
const getExamSubjectGradeParam = (params = {}) => {
  return axios.post(`${basePath}/getExamSubjectGradeParam`, params).then(res => res.data)
}
/**
 * 查询总分-报表等级参数
 * @author changh 2021-08-31T09:28:43+0800
 * @param  {data:{examId:""}}
 * @return 'result'      [description]
 */
const unreleaseSubjectReport = (params = {}) => {
  return axios.post(`${basePath}/unreleaseSubjectReport`, params).then(res => res.data)
}

export {
  getReportDownloadUrl,
  getOrgExams,
  searchOrgExams,
  getExamTrendComparisonHistory,
  examComparison,
  queryExamReportConfig,
  setExamReportConfig,
  publishReport,
  queryDownloadScoreURL,
  calcReport,
  batchCalcReport,
  queryDownloadReportURL,
  initExamSubjectResultData,
  checkSubjectResultUploaded,
  queryStudentScoreDetail,
  getExamGradeParam,
  getExamSubjectGradeParam,
  unreleaseSubjectReport
}



// WEBPACK FOOTER //
// ./src/model/report-model.js